import { render, staticRenderFns } from "./adDelete.vue?vue&type=template&id=72dc9f7c&scoped=true"
import script from "./adDelete.vue?vue&type=script&lang=js"
export * from "./adDelete.vue?vue&type=script&lang=js"
import style0 from "./adDelete.vue?vue&type=style&index=0&id=72dc9f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc9f7c",
  null
  
)

export default component.exports